import { Directive } from '@angular/core';

@Directive({
  selector: '[dojoFilterableListSummaryItem]',
  standalone: false,
})
export class FilterableListSummaryItemDirective {}
